import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import TextTooltipContent from '../../../Popover/_partials/TextTooltipContent';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import Button from '../../../Button';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './CommentTooltip.scss';
var CommentTooltip = function (_a) {
    var className = _a.className, children = _a.children, onDismiss = _a.onDismiss;
    return (React.createElement(SimplePopperPopover, { className: classnames(s['content'], className), placement: "top", secondaryPlacement: "start", portalClassName: s['portal'], usePortal: true, showArrow: true, popoverContent: React.createElement(TextTooltipContent, { textClassName: s['text'], tooltipText: 
            /* prettier-ignore */
            React.createElement(Trans, { i18nKey: "actionbar.comment.tooltip" },
                "Thanks for downloading. Show the artist some love!",
                React.createElement(Button, { view: "b34", onClick: onDismiss, className: s['dismiss-btn'], biData: {
                        evid: BiEventType.THUMB_CLICK_COMMENT,
                        sectionname: 'download_popup',
                    } }, "Leave a comment")) }) }, children));
};
CommentTooltip.displayName = 'CommentTooltip';
export default CommentTooltip;
//# sourceMappingURL=CommentTooltip.js.map